import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { BreadcrumbLine } from '../../../../../components/BreadcrumbLine/BreadcrumbLine';
import FilterAdvanced from '../../../../../components/Filter/FilterAdvanced/FilterAdvanced';
import { useForm } from '../../../../../hooks/useForm';
import { useLang } from '../../../../../language';
import { getURLQuery, getValuesParams } from '../../../../../helpers/helpers';
import queryString from 'query-string';
import FilterAdvanced2 from '../../../../../components/Filter/FilterAdvanced/FilterAdvanced2';
import { FilterFormHead } from './Filters/FilterFormHead';
import { AparatosServices } from './controllers/services/aparatos.service';
import { TableAparatos } from './TableAparatos';

const Aparatos = () => {

  const Lang = useLang()
  const location = useLocation()

  const BreadcrumbLineItems = [
    {
      title: Lang('APARATOS'),
      link: '/aparatos'
    }
  ]

  const [fetchAlquileresGET, fetchAlquileresGETData] = AparatosServices.GET()

  const defaultValuesSearchAlways = {
    producto: '',
    status: 'activos',
    idtipoevento: '',
  }

  const defaultValuesSearchSimple = {
    page: 1,
    limit: '',
    order: '',

  }

  const defaultValuesSearchAdvanced = {
    page: 1,
    limit: '',
    order: '',

    fechainicioinscripcion: '',
    fechafininscripcion: '',
  }

  const defaultValuesSearch = { ...defaultValuesSearchSimple, ...defaultValuesSearchAdvanced, ...defaultValuesSearchAlways }

  const params = queryString.parse(location.search);

  const [formValuesSearch, handleInputChangeSearch, handleFormChange, resetformValuesSearch] = useForm({
    page: Number(params.page) || defaultValuesSearch.page,
    limit: params.limit || defaultValuesSearch.limit,
    producto: params.producto || defaultValuesSearch.producto,
    order: params.order || defaultValuesSearch.order,

    idtipoevento: params.idtipoevento || defaultValuesSearch.idtipoevento,

    fechainicioinscripcion: params.fechainicioinscripcion || defaultValuesSearch.fechainicioinscripcion,
    fechafininscripcion: params.fechafininscripcion || defaultValuesSearch.fechafininscripcion,
    status: params.status || defaultValuesSearch.status,
  });

  const handleSearch = (e: any, formValues: any) => {

    if (e) {
      e.preventDefault();
    }

    // Obtener todos los valores existentes en el form de values Search
    const urlParams = getValuesParams(formValues)

    // Convertir esos valores del objeto a url amigable
    const query = getURLQuery(urlParams)

    // history.push(`?${query}`);
    window.history.replaceState(null, '', `?${query}`);

    if (formValues.page !== 1) {

      handleFormChange({
        ...formValues,
        page: 1
      });

    } else {

      let formValuesTemp = { ...formValues }

      Object.keys(formValuesTemp).forEach((k) => formValuesTemp[k] === '' && delete formValuesTemp[k]);

      fetchAlquileresGET({
        params: {
          ...formValuesTemp
        }
      })
    }
  }

  useEffect(() => {

    // Obtener todos los valores existentes en el form de values Search
    const urlParams = getValuesParams(formValuesSearch)

    // Convertir esos valores del objeto a url amigable
    const query = getURLQuery(urlParams)

    window.history.replaceState(null, '', `?${query}`);

    fetchAlquileresGET({
      params: {
        ...urlParams
      }
    })


  }, [formValuesSearch.page, formValuesSearch.order, formValuesSearch.limit])

  return (

    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className='d-flex justify-content-between align-items-center mb-1 Nav-top-DAPcon'>
            <BreadcrumbLine BreadcrumbLineItems={BreadcrumbLineItems} />
          </div>
        </div>

        <div className="col-12 mb-4">

          <FilterAdvanced2
            handleSearch={handleSearch}
            formValuesSearch={formValuesSearch}
            handleInputChangeSearch={handleInputChangeSearch}
            fetchData={fetchAlquileresGETData}
            resetformValuesSearch={resetformValuesSearch}

            defaultValuesSearchSimple={defaultValuesSearchSimple}
            defaultValuesSearchAdvanced={defaultValuesSearchAdvanced}
            defaultValuesSearchAlways={defaultValuesSearchAlways}
            handleFormChange={handleFormChange}
          >

            <FilterAdvanced2.Head label={Lang('BUSCADOR')}>

              <FilterFormHead
              // fetchParamsMultipleData={fetchParamsMultipleData}
              />

            </FilterAdvanced2.Head>

            <FilterAdvanced2.Body>

              {/* <FilterForm /> */}

            </FilterAdvanced2.Body>

          </FilterAdvanced2>

        </div>

        <div className="col-12">
          <TableAparatos
            data={fetchAlquileresGETData.data?.items}
            loading={fetchAlquileresGETData.loading}
            total={fetchAlquileresGETData.data?.total}
            perPage={fetchAlquileresGETData.data?.per_page}
            formValuesSearch={formValuesSearch}
            handleFormChange={handleFormChange}
          />
        </div>

      </div>

    </div>
  )

}

export default Aparatos;